import {Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'momentDuration'
})
export class MomentDurationPipe implements PipeTransform {

  transform(value: Date | string | moment.Moment, ...args: unknown[]): string {
    if (value === null || value === undefined) {
      return '';
    }
    return moment(value).fromNow();

  }

}
